var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.414,
    height: 59.415,
    viewBox: "0 0 59.414 59.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Path_1068",
    "data-name": "Path 1068",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2763.251 65.678h-19.185v4.084h16.3l-12.3 12.3a20.914 20.914 0 1 0 2.887 2.887l12.3-12.3v16.3h4.083V65.678zm-28.441 49.789a17.265 17.265 0 1 1 14.1-27.225 16.991 16.991 0 0 1 3.161 9.961 17.265 17.265 0 0 1-17.26 17.264z",
    style: {
      stroke: "none"
    },
    transform: "translate(-2710.921 -62.678)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2744.067 65.678v4.084h16.298l-12.304 12.303c-3.608-2.968-8.225-4.752-13.25-4.752-11.52 0-20.89 9.371-20.89 20.89s9.37 20.89 20.89 20.89c11.518 0 20.89-9.371 20.89-20.89 0-5.026-1.785-9.643-4.753-13.25l12.303-12.305v16.3h4.084v-23.27h-23.268m-9.256 49.789c-9.535 0-17.265-7.73-17.265-17.265s7.73-17.264 17.265-17.264c5.73 0 10.809 2.792 14.103 7.304 1.93 2.639 3.161 6.156 3.161 9.96 0 9.535-7.73 17.265-17.264 17.265m9.256-52.789h23.268c1.657 0 3 1.343 3 3v23.269c0 1.657-1.343 3-3 3h-4.084c-1.657 0-3-1.343-3-3v-9.056l-5.367 5.368c.964 1.491 1.758 3.083 2.37 4.756.96 2.622 1.446 5.377 1.446 8.187 0 13.174-10.717 23.891-23.89 23.891-13.172 0-23.89-10.717-23.89-23.89s10.718-23.89 23.89-23.89c2.811 0 5.566.486 8.188 1.446 1.673.612 3.265 1.406 4.756 2.37l5.368-5.367h-9.055c-1.657 0-3-1.343-3-3v-4.084c0-1.657 1.343-3 3-3zm-9.256 49.789c3.81 0 7.392-1.484 10.086-4.178 2.695-2.694 4.178-6.276 4.178-10.087 0-3.004-.917-5.913-2.582-8.19-2.82-3.86-7.077-6.074-11.682-6.074-3.81 0-7.393 1.483-10.087 4.178-2.694 2.694-4.178 6.276-4.178 10.086 0 3.81 1.484 7.393 4.178 10.087s6.276 4.178 10.087 4.178z",
    style: {
      fill: "#e86e6e",
      stroke: "none"
    },
    transform: "translate(-2710.921 -62.678)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIcon);
export default __webpack_public_path__ + "static/media/male-icon.5de1a0ce.svg";
export { ForwardRef as ReactComponent };